import { useEffect, useState } from "react";
import { classNames } from "../../shared/utility";
import ImportMediaDropzone from "./ImportMediaDropzone";
import { DocumentIcon } from "@heroicons/react/24/outline";

export default function MediaUi(props) {
  const {
    title,
    uploadedImage,
    isEdit,
    imageUrl,
    imageName,
    handleInputChange,
    onDelete,
    setUploadedImage,
  } = props;

  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
    if (imageUrl) {
      const extension = imageUrl.split(".").pop().toLowerCase();
      console.log("extension", extension);

      setIsPdf(extension === "pdf");
    }
  }, [imageUrl]);

  return (
    <div>
      <div className="flex space-x-2">
        <label
          htmlFor="imageName"
          className="block text-sm font-medium text-gray-900"
        >
          {title}
        </label>
      </div>
      {uploadedImage ? (
        <div>
          <img src={uploadedImage} height="200" width="200" alt="New logo" />
        </div>
      ) : isEdit ? (
        imageUrl ? (
          isPdf ? (
            <DocumentIcon
              className="h-32 w-32 text-black-400"
              aria-hidden="true"
            />
          ) : (
            <img
              src={imageUrl}
              alt={imageName}
              title={imageName}
              className="media-image rounded-md"
              height="200"
              width="200"
            />
          )
        ) : null
      ) : null}
      <div className="flex mt-2 gap-2">
        <ImportMediaDropzone
          fileName={imageName}
          handleInputChange={handleInputChange}
          setUploadedImage={setUploadedImage}
        />
        <a
          type="button"
          className={classNames(
            imageUrl
              ? "inline-flex items-center justify-center rounded-md bg-yellow-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellow-700"
              : "hidden"
          )}
          href={imageUrl}
          target="_blank"
          rel="noreferrer"
        >
          View
        </a>

        <button
          type="button"
          className={classNames(
            imageUrl
              ? "inline-flex items-center justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
              : "hidden"
          )}
          onClick={onDelete}
        >
          Delete
        </button>
      </div>
    </div>
  );
}
